import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StihlSearch } from '../models/search';


@Injectable({
  providedIn: 'root'
})
export class SearchService {

  private pathAPI = environment.urlAPI;
  private controller = "StihlSearch/";

  constructor(private http: HttpClient) { }

  public searchTerm(term: string, fromItem: number, toItem: number): Observable<StihlSearch> {
    return this.http.get<StihlSearch>(this.pathAPI + this.controller + term + '?fromItem=' + fromItem + '&toItem=' + toItem);
  }
}
